import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import IntlMessages from "@util/IntlMessages";
import { useDispatch, useSelector } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { deleteFile, sendFileToCloudStorage } from "../../../../services/restAPI/RestApi";
import { Message, Switch, Button, Radio, RadioGroup, Upload, Input } from "../../../BP2Components";
import { getBase64StringFromDataURL } from "../../../../util/Scripts";

import "./../AdvertisementList/advertisementListSettings.less";
import "../GlobalSettings/GlobalSettings.less";
import "./buttonSettings.less";

const ButtonImageSettings = ({ value, data }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const [boardLinks, setBoardLinks] = useState();
   const [settings, setSettings] = useState({
      ...value
   });
   const [customUrl, setCustomUrl] = useState();
   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };

   const boards = useSelector(({ user }) => user.boards);
   useEffect(() => {
      let userBoards = [];
      // Prepare list with board objects like {url, name} to map them as select options
      if (boards) {
         boards.map((board) => {
            if (board.sheets) {
               if (board.sheets.length === 1) {
                  userBoards.push({
                     url: `/boards/${board.id}/${board?.sheets?.[0]?.id}`,
                     name: `${board.name}`
                  });
               } else {
                  board.sheets.forEach((sheet) => {
                     userBoards.push({
                        url: `/boards/${board.id}/${sheet.id}`,
                        name: `${board.name} - ${sheet.name}`
                     });
                  });
               }
            }
         });
      }
      // Check if API saved board url is in option list. If it's not it must be a customUrl.
      let savedUrlFoundInUserBoards = false;
      userBoards.forEach((board) => {
         if (board.url === value.btnUrl) {
            savedUrlFoundInUserBoards = true;
         }
      });
      // If url is "" then we know that it's new buttonWidget's basic value so we want to give select input to users
      if (value.btnUrl === "") {
         setCustomUrl(false);
      } else {
         setCustomUrl(!savedUrlFoundInUserBoards);
      }

      setBoardLinks(userBoards);
   }, []);

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleChangeInput = (name) => (e) => {
      setSettings({ ...settings, [name]: +e.target.value });
   };
   const handleEditListBuilder = () => {
      if (settings.formId) {
         window.open(`/listbuilder?tab=formbuilder&formId=${settings.formId}`, "_blank");
      } else {
         Message.warning(intl.formatMessage({ id: "forms.selectForm" }) || "Please select a form first");
      }
   };

   const handleDeletePhoto = () => {
      Message.loading(intl.formatMessage({ id: "global.loading" }), 0);
      if (settings.imageFileId && !settings.imageSourceURL) {
         deleteFile(settings.imageFileId)
            .then(() => {
               setSettings({
                  ...settings,
                  imageFileId: null
               });
               Message.success(intl.formatMessage({ id: "global.done" }));
            })
            .catch(() => {
               Message.error(intl.formatMessage({ id: "global.error" }));
            })
            .finally(() => {
               Message.destroy();
            });
      } else {
         setSettings({
            ...settings,
            imageFileId: null,
            imageSourceURL: null
         });
         Message.destroy();
      }
   };

   const handleRadioChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };

   const handleUploadFile = (info) => {
      if (!info.type.startsWith("image/")) {
         Message.error(intl.formatMessage({ id: "forms.wrongFileType" }));
         return;
      }

      const cleanedType = info.type.replace(/^image\//, "");

      const reader = new FileReader();

      reader.onload = function (loadEvent) {
         const result = loadEvent.target.result;

         const base64 = getBase64StringFromDataURL(result);
         if (base64) {
            Message.loading(intl.formatMessage({ id: "global.loading" }));
            try {
               sendFileToCloudStorage(info.name, cleanedType, base64).then((res) => {
                  setSettings({
                     ...settings,
                     imageSourceURL: res?.data?.cloudStorage?.url
                  });
               });
               Message.success(`${intl.formatMessage({ id: "forms.uploadSucces" })} ${info.name}`);
            } catch (error) {
               console.log(error);
               Message.error(intl.formatMessage({ id: "forms.uploadFailed" }));
            } finally {
               Message.destroy();
            }
         }
      };
      reader.readAsDataURL(info);
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <div className="widget-settings__inner__label">
                     <IntlMessages id="settings.upload" />:
                     <div className="action-buttons">
                        <Upload onUpload={handleUploadFile} disabled={settings.imageSourceURL}>
                           <Button buttonType={settings.imageSourceURL ? "disabled" : "default"}>
                              <IntlMessages id="settings.upload" />
                           </Button>
                        </Upload>

                        <div className="photo-button">
                           <Button
                              onClick={handleDeletePhoto}
                              buttonType={
                                 settings.imageSourceURL || settings.imageFileId
                                    ? "default"
                                    : "disabled"
                              }
                           >
                              <IntlMessages id="delete" />
                           </Button>
                        </div>
                        {settings.imageSourceURL ? (
                           <div className="photo-button">
                              <img type="primary" src={settings.imageSourceURL} alt="" />
                           </div>
                        ) : null}
                     </div>
                  </div>
                  <label className="widget-settings__inner__label" key="imageHorizontalPosition">
                     <IntlMessages id="settings.imagePlacement" />:
                     <RadioGroup
                        onChange={handleRadioChange}
                        defaultValue={value.imageHorizontalPosition || "center"}
                        name="imageHorizontalPosition"
                     >
                        <Radio value={"center"}>
                           <IntlMessages id="settings.center" />
                        </Radio>
                        <Radio value={"left"}>
                           <IntlMessages id="settings.left" />
                        </Radio>
                        <Radio value={"right"}>
                           <IntlMessages id="settings.right" />
                        </Radio>
                     </RadioGroup>
                  </label>
                  <label className="widget-settings__inner__label" key="fillWidgetWithImage">
                     <IntlMessages id="settings.fillWidgetWithImage" />:
                     <Switch
                        name="fillWidgetWithImage"
                        onChange={(e) => handleSwitch(e, "fillWidgetWithImage")}
                        defaultChecked={value.fillWidgetWithImage}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="isImageClickable">
                     <IntlMessages id="settings.isImageClickable" />:
                     <div className="switch_with_label">
                        <Switch
                           name="isImageClickable"
                           onChange={(e) => handleSwitch(e, "isImageClickable")}
                           defaultChecked={value.isImageClickable}
                        >
                           <IntlMessages id="settings.isImageClickable" />
                        </Switch>
                     </div>
                  </label>
                  {/* <label className="widget-settings__inner__label" key="setWidthOrHeightImage">
                     <IntlMessages id="settings.setWidthOrHeightImage" />:
                     <RadioGroup
                        onChange={handleRadioChange}
                        defaultValue={value.setWidthOrHeightImage || false}
                        name="setWidthOrHeightImage"
                     >
                        <Radio value={false}>
                           <IntlMessages id="settings.width" />
                        </Radio>
                        <Radio value={true}>
                           <IntlMessages id="settings.height" />
                        </Radio>
                     </RadioGroup>
                  </label> */}
                  <label className="widget-settings__inner__label" key="xsImageSize">
                     <IntlMessages id="settings.buttonImageWidth" />:
                     <Input
                        type="number"
                        name="xsImageSize"
                        onChange={handleChangeInput("xsImageSize")}
                        defaultValue={value.xsImageSize}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="smImageSize">
                     <IntlMessages id="settings.imageHeight" />:
                     <Input
                        type="number"
                        name="smImageSize"
                        onChange={handleChangeInput("smImageSize")}
                        defaultValue={value.smImageSize}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="formId">
                     Form ID:
                     <div style={{ display: "flex", gap: "10px", width: "100%" }}>
                        <Input
                           type="text"
                           name="formId"
                           onChange={(e) => setSettings({ ...settings, formId: e.target.value })}
                           value={settings.formId}
                        />
                        <Button onClick={handleEditListBuilder} style={{ whiteSpace: "nowrap" }}>
                           <IntlMessages id="global.edit" />
                        </Button>
                     </div>
                  </label>
                  {/* they may be used in the future, for example as a different fields */}
                  {/* <label className="widget-settings__inner__label" key="mdImageSize">
                     <IntlMessages id="settings.mdImageSize" />:
                     <Input
                        type="number"
                        name="mdImageSize"
                        onChange={handleChangeInput("mdImageSize")}
                        defaultValue={value.mdImageSize || 70}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="lgImageSize">
                     <IntlMessages id="settings.lgImageSize" />:
                     <Input
                        type="number"
                        name="lgImageSize"
                        onChange={handleChangeInput("lgImageSize")}
                        defaultValue={value.lgImageSize || 100}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="xlImageSize">
                     <IntlMessages id="settings.xlImageSize" />:
                     <Input
                        type="number"
                        name="xlImageSize"
                        onChange={handleChangeInput("xlImageSize")}
                        defaultValue={value.xlImageSize || 130}
                     />
                  </label> */}
               </div>
               <Button key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default ButtonImageSettings;
